import script from "./ProcurementLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcurementLayout.vue?vue&type=script&setup=true&lang=js"

import "./ProcurementLayout.vue?vue&type=style&index=0&id=d450b38e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d450b38e"]])

export default __exports__